(function () {
  'use strict';

  // Preview navigation continuity.
  //
  // This store's primary domain is not served by Shopify yet. In an active
  // Shopify preview a request that carries the preview request parameters is
  // rendered in place, while the same path without them answers with the
  // primary-domain redirect and leaves the preview. Internal links are plain
  // root-relative paths with no query, so a second click would drop out of the
  // preview.
  //
  // This handler re-applies only the preview parameters that are ALREADY
  // present in the current URL. It never creates them, so a production page
  // (no preview parameters, no design mode) never activates it and never
  // gains a parameter.

  var PRESERVE_KEYS = ['preview_theme_id', '_fd'];
  var PREVIEW_VALUE = /^[0-9]+$/;
  var BLOCKED_PATH = /^\/(?:checkout|account|admin|services|cdn|cdn-cgi|payments?|preferences|password)(?:\/|$)/i;
  var ASSET_PATH = /\.(?:png|jpe?g|gif|webp|avif|svg|ico|css|js|mjs|map|json|xml|txt|pdf|zip|csv|woff2?|ttf|otf|eot|mp4|webm|mp3|wasm)(?:$|[?#])/i;

  function previewParams(search) {
    var out = {};
    var params;
    try {
      params = new URLSearchParams(search || '');
    } catch (error) {
      return out;
    }
    for (var index = 0; index < PRESERVE_KEYS.length; index++) {
      var key = PRESERVE_KEYS[index];
      var value = params.get(key);
      if (value !== null && PREVIEW_VALUE.test(value)) out[key] = value;
    }
    return out;
  }

  function hasPreviewParams(params) {
    for (var key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) return true;
    }
    return false;
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode === true);
  }

  function isPreviewActive() {
    return isDesignMode() || hasPreviewParams(previewParams(window.location.search));
  }

  // Returns the rewritten same-origin href, or null when the link must not be
  // touched (external origin, asset, checkout/account path, no preview state,
  // or already carrying every preserved parameter).
  function rewriteHref(rawHref, baseHref, params) {
    if (typeof rawHref !== 'string' || rawHref === '' || rawHref.charAt(0) === '#') return null;
    if (!hasPreviewParams(params)) return null;
    var base, target;
    try {
      base = new URL(baseHref);
      target = new URL(rawHref, baseHref);
    } catch (error) {
      return null;
    }
    if (target.protocol !== 'http:' && target.protocol !== 'https:') return null;
    if (target.origin !== base.origin) return null;
    if (BLOCKED_PATH.test(target.pathname)) return null;
    if (ASSET_PATH.test(target.pathname) || ASSET_PATH.test(rawHref)) return null;
    var changed = false;
    for (var key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) continue;
      if (target.searchParams.has(key)) continue;
      target.searchParams.set(key, params[key]);
      changed = true;
    }
    if (!changed) return null;
    return target.pathname + target.search + target.hash;
  }

  function onClick(event) {
    try {
      if (!event || event.defaultPrevented) return;
      if (typeof event.button === 'number' && event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var anchor = target.closest('a[href]');
      if (!anchor) return;
      if (anchor.hasAttribute('download') || anchor.hasAttribute('data-preview-nav-off')) return;
      var linkTarget = anchor.getAttribute('target');
      if (linkTarget && linkTarget !== '_self') return;
      var next = rewriteHref(
        anchor.getAttribute('href'),
        window.location.href,
        previewParams(window.location.search)
      );
      if (next) anchor.setAttribute('href', next);
    } catch (error) {
      // Navigation must never depend on this handler.
    }
  }

  function install() {
    try {
      if (!isPreviewActive()) return;
      document.addEventListener('click', onClick, true);
      api.installed = true;
    } catch (error) {
      // Stay inert rather than risk production navigation.
    }
  }

  var api = {
    preserveKeys: PRESERVE_KEYS.slice(),
    previewParams: previewParams,
    rewriteHref: rewriteHref,
    isPreviewActive: isPreviewActive,
    installed: false
  };

  window.AccioTeakPreviewNav = api;

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', install, { once: true });
    } else {
      install();
    }
  } catch (error) {
    // Stay inert.
  }
})();
